import { useStartedProjectsLayout } from "../hooks/use-started-projects-layout";
import { ScheduledProjectsSlider } from "./scheduled-projects-slider/scheduled-projects-slider";
import { SelectableProjectsCardGrid } from "./selectable-projects-card-grid";

export const SCHEDULED_PROJECTS_LIMIT = 6;

export function DefaultStartedProjectsLayout() {
  const { startItems, remainingItems } = useStartedProjectsLayout();

  return (
    <div className="flex flex-col space-y-6">
      <SelectableProjectsCardGrid projects={startItems} />
      <ScheduledProjectsSlider />
      <SelectableProjectsCardGrid projects={remainingItems} />
    </div>
  );
}
